module.exports = {
  i: {
    locale: 'zh-CN',
    select: {
      placeholder: '请选择',
      noMatch: '无匹配数据',
      loading: '加载中'
    },
    table: {
      noDataText: '暂无数据',
      noFilteredDataText: '暂无筛选结果',
      confirmFilter: '筛选',
      resetFilter: '重置',
      clearFilter: '全部'
    },
    datepicker: {
      selectDate: '选择日期',
      selectTime: '选择时间',
      startTime: '开始时间',
      endTime: '结束时间',
      clear: '清空',
      ok: '确定',
      datePanelLabel: '[yyyy年] [m月]',
      month: '月',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      year: '年',
      weekStartDay: '0',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        m1: '1月',
        m2: '2月',
        m3: '3月',
        m4: '4月',
        m5: '5月',
        m6: '6月',
        m7: '7月',
        m8: '8月',
        m9: '9月',
        m10: '10月',
        m11: '11月',
        m12: '12月'
      }
    },
    transfer: {
      titles: {
        source: '源列表',
        target: '目的列表'
      },
      filterPlaceholder: '请输入搜索内容',
      notFoundText: '列表为空'
    },
    modal: {
      okText: '确定',
      cancelText: '取消'
    },
    poptip: {
      okText: '确定',
      cancelText: '取消'
    },
    page: {
      prev: '上一页',
      next: '下一页',
      total: '共',
      item: '条',
      items: '条',
      prev5: '向前 5 页',
      next5: '向后 5 页',
      page: '条/页',
      goto: '跳至',
      p: '页'
    },
    rate: {
      star: '星',
      stars: '星'
    },
    tree: {
      emptyText: '暂无数据'
    },
    login: {
      username : '用户名',
      password :'密码',
      domain: '请选择领域',
      verificationCode:'验证码',
      administrators: '管理员登录',
      language:'语言',
      language_zh:'中文',
      language_ja:'日语',
      user_message:'请输入用户名',
      password_message:'请输入密码',
      password_length_message: '密码长度不能少于8位',
      verificationCode_message:'请输入验证码',
      examinationLanding: '研修/考试系统登录',
      land: '登 录',
      functionalClassification: '功能分类',
      rules: '本部及自社规程',
      research: '研 修',
      examination: '考 试',
      testResume: '受讲及考试履历',
      news: '消息',
      loginData: '请输入必填项',
      PersonalInformation: '个人信息',
      isInitPasswd: '您使用的是初始密码登录，请修改密码',
      passwdExpired: '您的密码已过期，请修改密码',
      area: '请选择国家地区',
      mobile: '请输入手机号',
      oldPassword: '请输入原密码',
      newPassword: '请输入新密码',
      newPasswordC: '请再输入新密码',
      forgetThePassword: '忘记密码',
      mobileVerificationCode: '手机验证码',
      resetPassword: '重新设置密码',
      getPhoneVerificationCode: '获取手机验证码',
      recapture: '后重新获取',
      gePhoneNumber: '获取手机验证码',
      company: '请选择公司',
      mobileCaptcha: '请输入手机验证码',
      passwdEq: '两次密码不同，请重新输入！',
      LoginMsg: '请登录系统！',
      returnHome: '返回首页',
      returnPrevious: '返回上一页',
      pwdQuestion:'密保问题',
      pwdAnswer:'密保答案',
      pwdForgetType:'找回密码方式',
      pwdForgetMsg:'手机号和密保问题至少输入一项，以便于找回密码',
      pwdForgetWarn:'请回答密保问题',
      pwdForgetTypeMsg:'请选择找回密码方式',
      noAuthEntry: '您没有权限进入'
    },
    system :{
      name:'Honda培训系统',
      news:'最新消息',
      pleaseReadFrontImg: '请先阅读完之前章节',
      pleaseWait: '请耐心阅读十秒后再阅读下一页',
      personNews: '个人消息',
      examinationSystem: '研修/考试系统',
      hondaChina: '本田技研工業(中国)投資有限公司',
      examinationRecords: '考试记录',
      signOut: '退出',
      administration: '管理端',
      study: '研修',
      details: '详情',
      online: '在线课程',
      face: '面授课程',
    },
    studyModule: {
      newPersonStudy: '新人研修',
      manageStudy: '管理人员进修',
      studyDetail: '研修详情'
    },
    studyColumn: {
      isMe: '是否管理员',
      name: '姓名',
      depName: '部门',
      endDate: '最終研修期間',
      studyStatus: '研修状况',
      studyName: '研修名称',
      bbOrzs: '本部/自社',
      isFinish: '是否完成',
      obj: '对象',
      desrc: '简介',
      date: '日期',
      signature: '状态',
      signatureNo: '未报名',
      signature0: '审核中',
      signature1: '待审核',
      signature2: '审核通过',
    },
    contacts: {
      title:"如有问题，请联系以下人员",
      name:'本田技研工业（中国）投资有限公司',
      department: '法务部'
    },

    resume: {
      testResume : '受讲及考试履历',
      studyTrain: '研修履历',
      examinationRecords: '听课记录及考试记录',
      listOfResume: '履历一览'
    },
    common : {
      research: '研修',
      examination: '考试',
    },
    test : {
      testPaper: '关于行动规范考试用纸',
      propose: '提出',
      safekeeping: '保管',
      answerDescrRight: '恭喜您回答正确',
      answerDescrWrong: '很遗憾您回答错误',
      answerDescr:'正确答案',
      answer:'答案详解',
      passExamination: '恭喜你，考试通过',
      examinationValidityPeriod: '考试还未开始或已超过考试截止时间',
      reExamination: '重新考试',
      saveOk: '保存成功',
      Yes:'√',
      No:'X',
      determine:'判定',
      preservation:'暂时保存',
      testNotPass: '您考试未通过，请重新考试!',
      seeImg:'查看图片'
    },
    search : {
      selfSocialRegulation: '本部及自社规程的发行',
      name: '名 称',
      operation: '操作',
      legalConstitution: '本部及法律章程'
    },
    news : {
      all: '全部',
      yes: '已读',
      no: '未读',
    },
    exam : {
      single: '单选题',
      multi: '多选题',
      judge: '判断题',
      fill: '填空题',
      ask: '问答题',
      msg:'未作答',
      message:'请作答试题',
    },
    courseware : {
      toExam: '去考试',
      name: '课程名称',
      signUpSuccess: '报名成功',
      signUp: '报名',
      examination: '考试名称',
      title: '标题',
      startDate: '开始时间',
      dep: '部门',
      course_architecture_names: '所属课程体系',
      courseType: '课程类型',
      orgName: '所属机构',
      operation: ' ',
    },
    resumeRecord :{
      number: '序号',
      user: '学员名称',
      title: '教材名',
      score: '得分',
      answerTimes: '考试回数',
      theEndTime: '最终考试时间',
      status: '状态',
      isPass: '是否通过',
      year: '年份',
      search: '搜索',
      staffNumber: '员工编号',
      staffInstitution: '部門名称',
      lastLearningTime: '最后的学习时间',
      derive: '导出',
      noChoice: '未选择',
      noStart: '未开始',
      complete: '完成',
      noComplete: '未完成'
    },
    isFinish: {
      finish: '已完成',
      noFinish: '未完成'
    },
    isPass :{
      yes: '是',
      no: '否'
    },
    resumeStatus :{
      yes: '提交',
      no: '保留',
    },
    changePassword:{
      password: '修改密码',
      cellPhoneNumber: '手机号',
      originalPassword: '原密码',
      newPassword: '新密码',
      confirmPassword: '再次确认新密码',
      preservation: '保存',
      title: '注：手机号和密保问题至少输入一项，以便于忘记密码时可通过手机验证码或回答密保问题修改密码'
    },
    SelectChapter:{
      chapter_name: '章节名称',
      file_size: '文件大小'
    },
    personalInformation: {
      modifyInformation: '修改个人信息',
      changePassword: '修改密码',
      viewLearningRecords: '查看学习记录',
      typeOfCompany: '公司类型',
      domain: '领域',
      departmentName: '所属部门',
      chineseName: '中文名字',
      japaneseName: '日文名字',
      age: '年龄',
      email: '邮箱',
      phoneNumber: '手机号',
      phoneAreaVal:'区号',
    },
    domains:{
      nbkzqy: '内部控制区域',
      rsly: '人事领域',
      itly: 'IT领域',
    },
    viewLearningRecords: {
      courseName: '课程名称',
      courseType: '课程类型',
      itsCurriculumSystem: '所属课程体系',
      completeState: '完成状态',
      lastLearningTime: '最后学习时间',
      schedule: '进度'
    },
    studyModelData: {
      name1: '研修申请',
      name2: '研修实施',
      yes: '是',
      no:'否'
    },
    jj: {
      jj: '聚焦',
      btn:'个人信息保护·数据安全/企业道德改善提案窗口',
      name:'资料名称',
      type:'分类',
      zt:'专题',
      download:'下载',
      content:'说明',
      title1:'个人信息保护・数据安全',
      title2:'企业伦理改善提案窗口'
    }
  }
};



// WEBPACK FOOTER //
// ./src/lang/zh-CN.js